import { Box, Grid } from "@mui/material";
import StatCard from "./StatCard";
import { StatMetric } from "./types";

export default function CategoryCard({
  metrics,
  layout = "2x2",
}: {
  metrics: StatMetric[];
  layout?: "2x2" | "1x2";
}) {
  return (
    <Box
      sx={{
        pb: 2,
        flex: layout === "1x2" ? "0 0 15%" : 1,
      }}
    >
      <Grid container spacing={0.5} columns={layout === "1x2" ? 1 : 2}>
        {metrics.map((metric) => (
          <Grid key={metric.name} item xs={1}>
            <StatCard {...metric} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
